import { Component, OnInit } from '@angular/core';
import { ReportApiService } from '../ApiServices/report-api.service';
import { IdList, ReportParameters } from '../Models/report-parameters';
import { SHIFT_SUMMARY } from '../Models/Report/SHIFT_SUMMARY';

@Component({
  selector: 'app-shift-summary',
  templateUrl: './shift-summary.component.html',
  styleUrls: ['./shift-summary.component.css']
})
export class ShiftSummaryComponent implements OnInit {

  constructor(private reportApiService: ReportApiService) { }

  reportParameters: ReportParameters;
  fromDate: string = '';
  toDate: string = '';



  shiftSummary: SHIFT_SUMMARY;

  ngOnInit(): void {
    this.shiftSummary = new SHIFT_SUMMARY();
    this.reportParameters = new ReportParameters();
    var now = new Date();
    this.fromDate = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + ' ' + now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds();
    this.toDate = this.fromDate;
  }
  ShowReport() {

    this.reportParameters.fromdate = this.fromDate;
    this.reportParameters.todate = this.toDate;

    this.reportApiService.SHIFT_SUMMARY(this.reportParameters).subscribe(w => {
      this.shiftSummary = w;

    })
  }

  PrintReport() {
    window.print();
  }
}
